import { useGlobalContext } from '@/context/Global/GlobalContext';
import { DashboardUserType } from '@/utils/enums';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const RouteFallback = () => {
  const navigate = useNavigate();
  const { session } = useGlobalContext();

  const url = window.location.pathname;

  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (session === undefined) return;
    if (session?.type === DashboardUserType.ADMIN) {
      if (url === '/') {
        navigate('/admin');
        return;
      } else {
        navigate('/admin/not-found');
        return;
      }
    }

    if (session?.type === DashboardUserType.SELLER) {
      if (url === '/') {
        navigate('/seller');
        return;
      }
      navigate('/seller/not-found');
      return;
    }

    if (url === '/') {
      navigate('/seller/login');
      return;
    }

    if (url.startsWith('/admin') || url === '/login/admin') {
      navigate('/admin/login');
      return;
    }
    if (url.startsWith('/seller') || url === '/login') {
      navigate('seller/login');
      return;
    }
    setNotFound(true);
    return;
  }, [session]);

  return <>{notFound ? 'NOT FOUND' : null}</>;
};
